export default __webpack_public_path__ + "static/media/failedproducts.d5d6e8c8.svg";